import Navbar from './components/Navbar';
import Hero from './components/Hero';

export default function Home() {
  return (
    <main className="relative bg-[#0f0f10] text-[#f5f0e6] min-h-screen">
      <Navbar />
      <Hero />
    </main>
  );
}